(() => {
  if (window.__ss26CompleteLookInitialised) return;
  window.__ss26CompleteLookInitialised = true;

  const railSelector = '[data-ss26-look-rail]';
  const buttonSelector = '[data-ss26-look-scroll]';

  const updateControls = (rail) => {
    const section = rail.closest('.ss26-look-builder');
    if (!section) return;

    const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
    const previous = section.querySelector('[data-ss26-look-scroll="previous"]');
    const next = section.querySelector('[data-ss26-look-scroll="next"]');

    if (previous) previous.disabled = rail.scrollLeft <= 2;
    if (next) next.disabled = rail.scrollLeft >= maxScroll - 2;
  };

  const initialiseRail = (rail) => {
    if (rail.dataset.ss26LookReady === 'true') return;
    rail.dataset.ss26LookReady = 'true';
    updateControls(rail);
    rail.addEventListener('scroll', () => updateControls(rail), { passive: true });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(() => updateControls(rail));
      observer.observe(rail);
    }
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll(railSelector).forEach(initialiseRail);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(buttonSelector);
    if (!button || button.disabled) return;

    const section = button.closest('.ss26-look-builder');
    const rail = section?.querySelector(railSelector);
    const card = rail?.querySelector('.ss26-look-family');
    if (!rail || !card) return;

    const railStyles = window.getComputedStyle(rail);
    const gap = Number.parseFloat(railStyles.columnGap || railStyles.gap) || 0;
    const direction = button.dataset.ss26LookScroll === 'previous' ? -1 : 1;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    rail.scrollBy({
      left: direction * (card.getBoundingClientRect().width + gap),
      behavior: prefersReducedMotion ? 'auto' : 'smooth'
    });
  });

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }
})();
